import React from "react";

import { Divider, Header } from "semantic-ui-react";

type HeaderCustomProps = {
  as?: string;
  hideDivider?: boolean;
  label: string;
};

const HeaderCustom: React.FC<HeaderCustomProps> = (props) => (
    <>
      <Header style={{ color: "#4e4e4e" }} as={props.as || "h3"}>
        {props.label}
      </Header>
      {!props.hideDivider && (
        <Divider style={{ borderTop: "1px solid rgb(238 233 233)" }} />
      )}
    </>
  );

export default HeaderCustom;